import { Anchor, Breadcrumbs, Grid, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import DetailedStatistics from '../../components/Stats/DetailedStatistics';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const page = `${Page['whatsappMessage']}`;

const WhatsappMessagesStatisticsPage = () => {
  const fetch = useFetch();

  const [whatsappMessage, setWhatsappMessage] = useState();
  const [error, setError] = useState();
  const { accountId, domainId, whatsappMessageId } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/whatsappMessages/${whatsappMessageId}`)
      .then(({ whatsappMessage }) => setWhatsappMessage(whatsappMessage))
      .catch(setError);
  }, [accountId, domainId, whatsappMessageId, fetch]);

  return (
    <>
      <Metadata title={`${page} | ${whatsappMessage?.name || 'Unnamed WhatApp message'}`} />
      <Breadcrumbs mb="md">
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/analytics`}>Home</Anchor>
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/whatsapp`}>{page}</Anchor>
        <Text>{whatsappMessage?.name || 'Unnamed WhatsApp message'}</Text>
      </Breadcrumbs>
      <Grid>
        <Grid.Col span={12}>
          {error ? (
            <ErrorMessage message={error.message} />
          ) : (
            <DetailedStatistics name={whatsappMessage?.name} scope="whatsappMessages" id={whatsappMessageId} />
          )}
        </Grid.Col>
      </Grid>
    </>
  );
};

export default WhatsappMessagesStatisticsPage;
